import { regex } from "common/formik/FormikSchema"
import * as yup from "yup"

const translationObject = {
  min: {
    he: "יש להזין לפחות",
    en: "Please enter at least",
  },
  max: {
    he: "יש להזין עד",
    en: "Please enter at most",
  },
  required: {
    he: "נדרש",
    en: "Required",
  },
  email: {
    he: "כתובת דואר אלקטרוני לא תקינה",
    en: "Invalid email address",
  },
  phone: {
    he: "מספר טלפון לא תקין",
    en: "Invalid phone number",
  },
  letters: {
    he: "יש להזין אותיות בלבד",
    en: "Only letters are allowed",
  },
}

export const createSchemaContactUs = (language: "he" | "en") => {
  const schemaContactUs = yup
    .object({
      first_name: yup
        .string()
        .matches(regex.singleName, translationObject["letters"][language])
        .min(2, `${translationObject["min"][language]} 2`)
        .max(40, `${translationObject["max"][language]} 40`)
        .required(translationObject["required"][language]),
      last_name: yup
        .string()
        .matches(regex.singleName, translationObject["letters"][language])
        .min(2, `${translationObject["min"][language]} 2`)
        .max(80, `${translationObject["max"][language]} 80`)
        .required(translationObject["required"][language]),
      email: yup
        .string()
        .email(translationObject["email"][language])
        .max(80, `${translationObject["max"][language]} 80`)
        .required(translationObject["required"][language]),
      mobile: yup
        .string()
        .matches(regex.phoneNumber, translationObject["phone"][language])
        .length(10, translationObject["phone"][language])
        .required(translationObject["required"][language])
        .max(10, `${translationObject["max"][language]} 10`),
      company: yup.string().max(40, `${translationObject["max"][language]} 40`),
      "00N8d0000042MfL": yup
        .string()
        .max(200, `${translationObject["max"][language]} 200`),
      "00N8d000008RbDs": yup.boolean(),
    })
    .defined()
  return schemaContactUs
}
